




















































import { filter, IterateeShorthand, orderBy, maxBy } from 'lodash'
import { mapActions } from 'vuex'

import { RunningProcess, Process, ProcessLog, ProcessDetail } from '@/store/workflow/types'
import Provide from '@/components/Provide'

import Vue from 'vue'
export default Vue.extend({
  components: { Provide },
  computed: {
    filters(): ProcessDetail {
      const processFilter = {} as ProcessDetail
      processFilter.log = {} as ProcessLog

      if (this.name && processFilter.log) {
        processFilter.log.business_key = this.name
      }
      if (this.inProcess && processFilter.log) {
        processFilter.log.super_instance_id = this.inProcess.id
      }
      if (this.flowchart && processFilter.log) {
        processFilter.log.definition_key = this.flowchart
      }
      if (this.onlyActive && processFilter) {
        processFilter.log.end_time = null
      }

      // processFilter by current case id
      if (processFilter.log) {
        processFilter.log.case_id = this.case ? this.case : this.$store.getters.currentCaseId
      }
      return processFilter
    },
    processDetails(): ProcessDetail[] {
      return this.$store.getters['workflow/processDetails']
    },
    filteredProcessDetails(): any[] {
      const details = filter(this.processDetails, this.filters)
      if (this.onlyLatest) {
        const latest = maxBy(details, 'log.start_time')
        if (latest) {
          return [latest]
        } else {
          return []
        }
      } else {
        return orderBy(details, 'log.start_time', 'asc')
      }
    },
  },
  methods: {
    ...mapActions('workflow', ['cancelProcess', 'startProcess', 'sendMessage']),
  },
  inject: {
    process: {
      default: null,
    },
  },
  props: {
    case: {
      type: String,
    },
    name: {
      type: String,
    },
    flowchart: {
      type: String,
    },
    onlyLatest: {
      type: Boolean,
      default: false,
    },
    onlyActive: {
      type: Boolean,
      default: false,
    },
    inProcess: {
      type: Object as () => Process,
      default(): Process | null {
        return (this as any).process
      },
    },
  },
})
